import React, { useEffect, useState } from 'react'
import * as PosService from '../../Services/pos-service'
import { FormControl, Grid, RadioGroup } from '@mui/material';
import CustomRadio from '../../Components/custom-radio/CustomRadio';

function PosRequestChangeFrequency({ objectDto, lang, setObjectDto }) {
    const windowSize = PosService.getSizeWindows();
    const [selectedValue, setSelectedValue] = useState(objectDto.frequency !== undefined && objectDto.frequency !== null && objectDto.frequency !== 0 ? objectDto.frequency : '');
    function onValueRadioChange(event) {
        if (event.target.value === "1") {
            setObjectDto({ ...objectDto, frequency: 1 });
        }
        else if (event.target.value === "2") {
            setObjectDto({ ...objectDto, frequency: 2 })
        }
        else if (event.target.value === "4") {
            setObjectDto({ ...objectDto, frequency: 4 })
        }
    }

    useEffect(() => {
        if (objectDto.frequency !== undefined) {
            setSelectedValue(objectDto.frequency);
        }
    }, [objectDto]);

    return (
        <div style={{ display: "block", borderBottom: "2px solid #c4960c", marginBottom: "1%" }}>
            <div data-toggle="collapse" data-target="#search-box-4" className={"header-box"} id="search-box-4-header">
                <h2 className="title-box  description-large-customer">
                    {lang('poschangefrequency').toUpperCase()}
                </h2>
            </div>
            <div className={"collapse in"} id="search-box-4">
                <Grid container spacing={0} className='border-box-sc row' sx={{ paddingLeft: "10px", marginBottom: "10px" }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth disabled={objectDto.saved === 1}>
                            <RadioGroup row={windowSize[0] > 991 ? true : false} value={selectedValue} onChange={onValueRadioChange} className="col-md-12 form-group">
                                <Grid item xs={12} sm={4} align="left" className="col-md-4">
                                    <CustomRadio title={lang('policyfrequency1')} value={1} id="frequency1" className="iCheck-radio" />
                                </Grid>
                                <Grid item xs={12} sm={4} align="left" className="col-md-4">
                                    <CustomRadio title={lang('policyfrequency2')} value={2} id="frequency2" className="iCheck-radio" />
                                </Grid>
                                <Grid item xs={12} sm={4} align="left" className="col-md-4">
                                    <CustomRadio title={lang('policyfrequency4')} value={4} id="frequency4" className="iCheck-radio" />
                                </Grid>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default PosRequestChangeFrequency